var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import ErrorMsg from "../../CommonComponent/ErrorMsg";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import BottomInputMsg from "@frameworks/web/components/features/TOC/CommonTocComponent/Stock/BottomInputMsg";
import InputField from "@frameworks/web/components/generic/inputField";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useSelector } from "react-redux";
import { EUpiAction, } from "@frameworks/web/components/features/FundTransfer/Funds/AddUpiIdFundTransfer";
import { useLocation, useNavigate } from "react-router-dom";
import { EFundRoutes } from "@frameworks/web/components/features/FundTransfer/Constant";
import { upiExp } from "@frameworks/web/utils/regex";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var AddNewUpidData = function () {
    var device = DeviceContext();
    var location = useLocation();
    var navigate = useNavigate();
    var _a = __read(useState(""), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState([{ title: "", value: "" }]), 2), bankList = _b[0], setBankList = _b[1];
    var _c = __read(useState([
        { display: "", value: "" },
    ]), 2), bankListMob = _c[0], setBankListMob = _c[1];
    var _d = __read(useState({
        upiId: "",
        isSetPrimary: false,
    }), 2), newUpiData = _d[0], setNewUpiData = _d[1];
    var _e = __read(useState([{ title: "", value: "" }]), 2), upiList = _e[0], setUpiList = _e[1];
    var _f = __read(useState(bankList[0]), 2), selectedBank = _f[0], setSelectedBank = _f[1];
    var _g = __read(useState(upiList[0]), 2), selectedUpi = _g[0], setSelectedUpi = _g[1];
    var _h = __read(useState([
        { display: "", value: "" },
    ]), 2), upiListMob = _h[0], setUpiListMob = _h[1];
    var _j = __read(useState(bankListMob[0].value), 2), selectedBankMob = _j[0], setSelectedBankMob = _j[1];
    var _k = __read(useState(upiListMob[0].value), 2), selectedUpiMob = _k[0], setSelectedUpiMob = _k[1];
    var bankDetails = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.fundTransfer) === null || _a === void 0 ? void 0 : _a.bankDetailsReducer) === null || _b === void 0 ? void 0 : _b.data; }
    // _.isEqual
    );
    var navigateToFund = function (bankid, upid) {
        navigate("/fund-transfer?fundType=".concat(EFundRoutes.ADD_FUNDS), {
            state: {
                bank: bankid,
                upi: upid,
                addUpi: true,
                backRoute: window.location.href,
            },
        });
    };
    var handleDataChange = function (action, val) {
        switch (action) {
            case EUpiAction.UPDATE_UPI_ID:
                setNewUpiData(__assign(__assign({}, newUpiData), { upiId: val }));
                break;
            case EUpiAction.UPDATE_PRIMARY:
                setNewUpiData(__assign(__assign({}, newUpiData), { isSetPrimary: val }));
                break;
        }
    };
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (bankDetails &&
            (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankAccounts) &&
            ((_a = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var list_1 = [];
            var listMob_1 = [];
            (_b = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankAccounts) === null || _b === void 0 ? void 0 : _b.forEach(function (bank) {
                list_1.push({
                    title: bank.bankName + " " + bank.bankAccountNo,
                    value: bank.bankAccountNo,
                });
                listMob_1.push({
                    display: bank.bankName + " " + bank.bankAccountNo,
                    value: bank.bankAccountNo,
                });
            });
            setBankList(list_1);
            setBankListMob(listMob_1);
            var latest = (_c = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankAccounts) === null || _c === void 0 ? void 0 : _c.filter(function (bank) { return bank.latest === true; });
            if (latest.length > 0) {
                setSelectedBank({
                    title: ((_d = latest[0]) === null || _d === void 0 ? void 0 : _d.bankName) + " " + ((_e = latest[0]) === null || _e === void 0 ? void 0 : _e.bankAccountNo),
                    value: (_f = latest[0]) === null || _f === void 0 ? void 0 : _f.bankAccountNo,
                });
                setSelectedBankMob((_g = latest[0]) === null || _g === void 0 ? void 0 : _g.bankName);
            }
            else {
                setSelectedBank(list_1[0]);
                setSelectedBankMob((_h = listMob_1[0]) === null || _h === void 0 ? void 0 : _h.value);
            }
        }
        if (bankDetails && (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.upis) && ((_j = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.upis) === null || _j === void 0 ? void 0 : _j.length)) {
            var upiList_1 = [];
            var upiListMob_1 = [];
            (_k = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.upis) === null || _k === void 0 ? void 0 : _k.map(function (upi) {
                upiList_1.push({
                    title: upi.upi,
                    value: upi.upi,
                });
                upiListMob_1.push({
                    display: upi.upi,
                    value: upi.upi,
                });
            });
            setUpiList(upiList_1);
            setSelectedUpi(upiList_1[0]);
            setUpiListMob(upiListMob_1);
            setSelectedUpiMob(upiListMob_1[0].value);
        }
    }, [bankDetails]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "add-new-upiid mt-2" },
            device && (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "mbt-45 upi-info-btn" },
                React.createElement(ErrorMsg, { title: React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1" }, "To verify UPI ID, you need to transer Rs.50 to your demat account")) }))),
            React.createElement("div", { className: "grid-2" },
                React.createElement("div", null,
                    React.createElement("div", { className: "mb-10 DMSanM_14_500" }, "Bank Accounts"),
                    React.createElement(EquityDropdown, { selectedDefaultVal: selectedBank, itemlist: bankList, defaultVal: true, selectedValue: setSelectedBank, externalClassname: "common-new-drp new-upi-drp common-dropdown-toc", bigIcon: true, align: "start" }),
                    React.createElement(BottomInputMsg, { message: "Primary Account", showlink: false, parentClass: "mgt-5" })),
                React.createElement("div", null,
                    React.createElement("div", { className: "mb-10 DMSanM_14_500" }, "UPI ID"),
                    React.createElement(InputField, { className: "h-50", placeholderClassName: "RobotoR_14_400 txt-midnight-blue", placeholder: "Enter UPI linked to above account", defaultValue: newUpiData === null || newUpiData === void 0 ? void 0 : newUpiData.upiId, onChange: function (val) {
                            return handleDataChange(EUpiAction.UPDATE_UPI_ID, val);
                        }, value: newUpiData === null || newUpiData === void 0 ? void 0 : newUpiData.upiId, pattern: upiExp, name: "upid", onBlur: function (error) {
                            if (error === null || error === void 0 ? void 0 : error.required) {
                                setError("UPI ID is Required");
                            }
                            else if (!error.pattern) {
                                setError("Invalid UPI, Please cross check the the entered UPI ID");
                            }
                            else {
                                setError(undefined);
                            }
                        }, required: true, errorText: error }),
                    React.createElement("div", { className: "d-flex align-items-center DMSansNormal_12_400 txt_primaryGrey pt-2 check-agree-upi check-agree brdbottom-none gap-" },
                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckDefault", checked: newUpiData === null || newUpiData === void 0 ? void 0 : newUpiData.isSetPrimary, onChange: function (e) {
                                return handleDataChange(EUpiAction.UPDATE_PRIMARY, e.target.checked);
                            } }),
                        React.createElement("div", { className: "agree-button d-flex" }, "Make this as primary ID")),
                    device && (device === null || device === void 0 ? void 0 : device.isMobile) && (React.createElement("div", { className: "mbt-45 upi-info-btn" },
                        React.createElement(ErrorMsg, { title: React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1" }, "To verify UPI ID, you need to transer Rs.50 to your demat account")) }))))),
            React.createElement("div", null,
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Verify UPI ID", className: "".concat((device === null || device === void 0 ? void 0 : device.isMobile) ? "w-100" : ""), disabled: !upiExp.test(newUpiData.upiId), onClick: function () {
                        navigateToFund(selectedBank.value, newUpiData.upiId);
                    } })))));
};
export default AddNewUpidData;
